import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { ComunicadoSistemaCriteria } from "@workflow/types";

import { comunicadoSistemaService } from "@/services/api/comunicado-sistema.service";

const MINUTE = 1000 * 60;

export const comunicadoSistemaKeys = {
  all: ["comunicados-sistema"] as const,
  vigentes: () => [...comunicadoSistemaKeys.all, "vigentes"] as const,
  lists: () => [...comunicadoSistemaKeys.all, "list"] as const,
  list: (criteria: ComunicadoSistemaCriteria) =>
    [...comunicadoSistemaKeys.lists(), criteria] as const,
  historicos: () => [...comunicadoSistemaKeys.all, "historico"] as const,
  historico: (criteria: ComunicadoSistemaCriteria) =>
    [...comunicadoSistemaKeys.historicos(), criteria] as const,
  historicoFiltros: () => [...comunicadoSistemaKeys.historicos(), "filtros"] as const,
  filtros: () => [...comunicadoSistemaKeys.all, "filtros"] as const,
  resumo: () => [...comunicadoSistemaKeys.all, "resumo"] as const,
  details: () => [...comunicadoSistemaKeys.all, "detail"] as const,
  detail: (id: number) => [...comunicadoSistemaKeys.details(), id] as const,
  pendentes: (id: number) => [...comunicadoSistemaKeys.all, "pendentes", id] as const,
};

export const comunicadoSistemaQueries = {
  /** Polling gentil: revalida a cada poucos minutos + no foco da janela. */
  vigentes: () =>
    queryOptions({
      queryKey: comunicadoSistemaKeys.vigentes(),
      queryFn: () => comunicadoSistemaService.listVigentes(),
      staleTime: 2 * 60 * 1000,
      refetchInterval: 5 * 60 * 1000,
      // Falha na comunicação não pode espalhar erro: as superfícies apenas somem.
      retry: 1,
    }),

  list: (criteria: ComunicadoSistemaCriteria) =>
    queryOptions({
      queryKey: comunicadoSistemaKeys.list(criteria),
      queryFn: () => comunicadoSistemaService.listagem(criteria),
      placeholderData: keepPreviousData,
      staleTime: 30 * 1000,
    }),

  historico: (criteria: ComunicadoSistemaCriteria) =>
    queryOptions({
      queryKey: comunicadoSistemaKeys.historico(criteria),
      queryFn: () => comunicadoSistemaService.listHistorico(criteria),
      placeholderData: keepPreviousData,
      staleTime: 30 * 1000,
    }),

  historicoFiltros: () =>
    queryOptions({
      queryKey: comunicadoSistemaKeys.historicoFiltros(),
      queryFn: () => comunicadoSistemaService.getHistoricoFiltros(),
      staleTime: 30 * MINUTE,
    }),

  filtros: () =>
    queryOptions({
      queryKey: comunicadoSistemaKeys.filtros(),
      queryFn: () => comunicadoSistemaService.getFiltros(),
      staleTime: 30 * MINUTE,
    }),

  resumo: () =>
    queryOptions({
      queryKey: comunicadoSistemaKeys.resumo(),
      queryFn: () => comunicadoSistemaService.getResumo(),
      staleTime: 30 * 1000,
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: comunicadoSistemaKeys.detail(id),
      queryFn: () => comunicadoSistemaService.getById(id),
    }),

  pendentes: (id: number) =>
    queryOptions({
      queryKey: comunicadoSistemaKeys.pendentes(id),
      queryFn: () => comunicadoSistemaService.listPendentes(id),
    }),
};
